import { render } from "./TaskDescriptionEditor.vue?vue&type=template&id=4acc45e8"
import script from "./TaskDescriptionEditor.vue?vue&type=script&lang=js"
export * from "./TaskDescriptionEditor.vue?vue&type=script&lang=js"

import "./TaskDescriptionEditor.vue?vue&type=style&index=0&id=4acc45e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__